type LocationPathSegment = {
  id: string;
  en: string;
  ar: string;
};

export type FlatLocation = {
  id: string;
  en: string;
  ar: string;
  city?: true;
  parentId?: string;
  path: LocationPathSegment[]; // ancestors from root -> parent
  // Precomputed strings to avoid per-render join operations
  pathEn?: string;
  pathAr?: string;
};

export const FLAT_LOCATIONS: FlatLocation[] = [
  {
    "id": "1",
    "en": "Alexandria",
    "ar": "الإسكندرية",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  },
  {
    "id": "2",
    "en": "Bibliotheca Alexandrina",
    "ar": "مكتبة الإسكندرية",
    "parentId": "1",
    "path": [
      {
        "id": "1",
        "en": "Alexandria",
        "ar": "الإسكندرية"
      }
    ],
    "pathEn": "Alexandria",
    "pathAr": "الإسكندرية"
  },
  {
    "id": "3",
    "en": "Citadel of Qaitbay",
    "ar": "قلعة قايتباي",
    "parentId": "1",
    "path": [
      {
        "id": "1",
        "en": "Alexandria",
        "ar": "الإسكندرية"
      }
    ],
    "pathEn": "Alexandria",
    "pathAr": "الإسكندرية"
  },
  {
    "id": "4",
    "en": "Lighthouse of Alexandria",
    "ar": "منارة الإسكندرية",
    "parentId": "1",
    "path": [
      {
        "id": "1",
        "en": "Alexandria",
        "ar": "الإسكندرية"
      }
    ],
    "pathEn": "Alexandria",
    "pathAr": "الإسكندرية"
  },
  {
    "id": "5",
    "en": "Catacombs of Kom El Shoqafa",
    "ar": "مقابر كوم الشقافة",
    "parentId": "1",
    "path": [
      {
        "id": "1",
        "en": "Alexandria",
        "ar": "الإسكندرية"
      }
    ],
    "pathEn": "Alexandria",
    "pathAr": "الإسكندرية"
  },
  {
    "id": "6",
    "en": "Pompey's Pillar",
    "ar": "عمود السواري",
    "parentId": "1",
    "path": [
      {
        "id": "1",
        "en": "Alexandria",
        "ar": "الإسكندرية"
      }
    ],
    "pathEn": "Alexandria",
    "pathAr": "الإسكندرية"
  },
  {
    "id": "7",
    "en": "Montaza Palace",
    "ar": "قصر المنتزه",
    "parentId": "1",
    "path": [
      {
        "id": "1",
        "en": "Alexandria",
        "ar": "الإسكندرية"
      }
    ],
    "pathEn": "Alexandria",
    "pathAr": "الإسكندرية"
  },
  {
    "id": "8",
    "en": "Corniche",
    "ar": "كورنيش الإسكندرية",
    "parentId": "1",
    "path": [
      {
        "id": "1",
        "en": "Alexandria",
        "ar": "الإسكندرية"
      }
    ],
    "pathEn": "Alexandria",
    "pathAr": "الإسكندرية"
  },
  {
    "id": "9",
    "en": "Roman Amphitheater",
    "ar": "المسرح الروماني",
    "parentId": "1",
    "path": [
      {
        "id": "1",
        "en": "Alexandria",
        "ar": "الإسكندرية"
      }
    ],
    "pathEn": "Alexandria",
    "pathAr": "الإسكندرية"
  },
  {
    "id": "10",
    "en": "Stanley Bridge",
    "ar": "كوبري ستانلي",
    "parentId": "1",
    "path": [
      {
        "id": "1",
        "en": "Alexandria",
        "ar": "الإسكندرية"
      }
    ],
    "pathEn": "Alexandria",
    "pathAr": "الإسكندرية"
  },
  {
    "id": "11",
    "en": "Monastery of St. Mina",
    "ar": "دير مار مينا",
    "parentId": "1",
    "path": [
      {
        "id": "1",
        "en": "Alexandria",
        "ar": "الإسكندرية"
      }
    ],
    "pathEn": "Alexandria",
    "pathAr": "الإسكندرية"
  },
  {
    "id": "12",
    "en": "Mamoura Beach",
    "ar": "شاطىء المعمورة",
    "parentId": "1",
    "path": [
      {
        "id": "1",
        "en": "Alexandria",
        "ar": "الإسكندرية"
      }
    ],
    "pathEn": "Alexandria",
    "pathAr": "الإسكندرية"
  },
  {
    "id": "13",
    "en": "Alexandria Aquarium",
    "ar": "متحف الأحياء المائية",
    "parentId": "1",
    "path": [
      {
        "id": "1",
        "en": "Alexandria",
        "ar": "الإسكندرية"
      }
    ],
    "pathEn": "Alexandria",
    "pathAr": "الإسكندرية"
  },
  {
    "id": "14",
    "en": "Serapeum",
    "ar": "سرابيوم",
    "parentId": "1",
    "path": [
      {
        "id": "1",
        "en": "Alexandria",
        "ar": "الإسكندرية"
      }
    ],
    "pathEn": "Alexandria",
    "pathAr": "الإسكندرية"
  },
  {
    "id": "15",
    "en": "Alexandria National Museum",
    "ar": "متحف الأسكندرية القومي",
    "parentId": "1",
    "path": [
      {
        "id": "1",
        "en": "Alexandria",
        "ar": "الإسكندرية"
      }
    ],
    "pathEn": "Alexandria",
    "pathAr": "الإسكندرية"
  },
  {
    "id": "16",
    "en": "Graeco-Roman Museum",
    "ar": "المتحف اليوناني الروماني",
    "parentId": "1",
    "path": [
      {
        "id": "1",
        "en": "Alexandria",
        "ar": "الإسكندرية"
      }
    ],
    "pathEn": "Alexandria",
    "pathAr": "الإسكندرية"
  },
  {
    "id": "17",
    "en": "Royal Jewelry Museum",
    "ar": "متحف المجوهرات الملكية",
    "parentId": "1",
    "path": [
      {
        "id": "1",
        "en": "Alexandria",
        "ar": "الإسكندرية"
      }
    ],
    "pathEn": "Alexandria",
    "pathAr": "الإسكندرية"
  },
  {
    "id": "18",
    "en": "Cavafy Museum",
    "ar": "متحف كفافيس",
    "parentId": "1",
    "path": [
      {
        "id": "1",
        "en": "Alexandria",
        "ar": "الإسكندرية"
      }
    ],
    "pathEn": "Alexandria",
    "pathAr": "الإسكندرية"
  },
  {
    "id": "19",
    "en": "El-Mursi Abu al-Abbas Mosque",
    "ar": "مسجد المرسي ابو العباس",
    "parentId": "1",
    "path": [
      {
        "id": "1",
        "en": "Alexandria",
        "ar": "الإسكندرية"
      }
    ],
    "pathEn": "Alexandria",
    "pathAr": "الإسكندرية"
  },
  {
    "id": "20",
    "en": "Heracleion-Thonis",
    "ar": "مدينة هرقليون",
    "parentId": "1",
    "path": [
      {
        "id": "1",
        "en": "Alexandria",
        "ar": "الإسكندرية"
      }
    ],
    "pathEn": "Alexandria",
    "pathAr": "الإسكندرية"
  },
  {
    "id": "21",
    "en": "Abu Qir Bay",
    "ar": "خليج أبو قير",
    "parentId": "1",
    "path": [
      {
        "id": "1",
        "en": "Alexandria",
        "ar": "الإسكندرية"
      }
    ],
    "pathEn": "Alexandria",
    "pathAr": "الإسكندرية"
  },
  {
    "id": "22",
    "en": "Nelson's Island",
    "ar": "جزيرة جريشة",
    "parentId": "1",
    "path": [
      {
        "id": "1",
        "en": "Alexandria",
        "ar": "الإسكندرية"
      }
    ],
    "pathEn": "Alexandria",
    "pathAr": "الإسكندرية"
  },
  {
    "id": "23",
    "en": "Abusir",
    "ar": "أبو صير",
    "parentId": "1",
    "path": [
      {
        "id": "1",
        "en": "Alexandria",
        "ar": "الإسكندرية"
      }
    ],
    "pathEn": "Alexandria",
    "pathAr": "الإسكندرية"
  },
  {
    "id": "24",
    "en": "Aswan",
    "ar": "اسوان",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  },
  {
    "id": "25",
    "en": "Abu Simbel Temple",
    "ar": "معبد أبو سمبل",
    "parentId": "24",
    "path": [
      {
        "id": "24",
        "en": "Aswan",
        "ar": "اسوان"
      }
    ],
    "pathEn": "Aswan",
    "pathAr": "اسوان"
  },
  {
    "id": "26",
    "en": "Temple of Philae",
    "ar": "معبد فيلة",
    "parentId": "24",
    "path": [
      {
        "id": "24",
        "en": "Aswan",
        "ar": "اسوان"
      }
    ],
    "pathEn": "Aswan",
    "pathAr": "اسوان"
  },
  {
    "id": "27",
    "en": "Nubian Village",
    "ar": "القرية النوبية",
    "parentId": "24",
    "path": [
      {
        "id": "24",
        "en": "Aswan",
        "ar": "اسوان"
      }
    ],
    "pathEn": "Aswan",
    "pathAr": "اسوان"
  },
  {
    "id": "28",
    "en": "Nubian Museum",
    "ar": "المتحف النوبي",
    "parentId": "24",
    "path": [
      {
        "id": "24",
        "en": "Aswan",
        "ar": "اسوان"
      }
    ],
    "pathEn": "Aswan",
    "pathAr": "اسوان"
  },
  {
    "id": "29",
    "en": "Elephantine Island",
    "ar": "جزيرة إلفنتين",
    "parentId": "24",
    "path": [
      {
        "id": "24",
        "en": "Aswan",
        "ar": "اسوان"
      }
    ],
    "pathEn": "Aswan",
    "pathAr": "اسوان"
  },
  {
    "id": "30",
    "en": "Aswan Market",
    "ar": "سوق أسوان",
    "parentId": "24",
    "path": [
      {
        "id": "24",
        "en": "Aswan",
        "ar": "اسوان"
      }
    ],
    "pathEn": "Aswan",
    "pathAr": "اسوان"
  },
  {
    "id": "31",
    "en": "Temple of Kom Ombo",
    "ar": "معبد كوم أمبو",
    "parentId": "24",
    "path": [
      {
        "id": "24",
        "en": "Aswan",
        "ar": "اسوان"
      }
    ],
    "pathEn": "Aswan",
    "pathAr": "اسوان"
  },
  {
    "id": "32",
    "en": "Animalia",
    "ar": "انيماليا",
    "parentId": "24",
    "path": [
      {
        "id": "24",
        "en": "Aswan",
        "ar": "اسوان"
      }
    ],
    "pathEn": "Aswan",
    "pathAr": "اسوان"
  },
  {
    "id": "33",
    "en": "Kitchener's Island",
    "ar": "جزيرة النباتات",
    "parentId": "24",
    "path": [
      {
        "id": "24",
        "en": "Aswan",
        "ar": "اسوان"
      }
    ],
    "pathEn": "Aswan",
    "pathAr": "اسوان"
  },
  {
    "id": "34",
    "en": "Monastery of St. Simeon",
    "ar": "دير الأنبا سمعان",
    "parentId": "24",
    "path": [
      {
        "id": "24",
        "en": "Aswan",
        "ar": "اسوان"
      }
    ],
    "pathEn": "Aswan",
    "pathAr": "اسوان"
  },
  {
    "id": "35",
    "en": "Aswan High Dam",
    "ar": "السد العالي",
    "parentId": "24",
    "path": [
      {
        "id": "24",
        "en": "Aswan",
        "ar": "اسوان"
      }
    ],
    "pathEn": "Aswan",
    "pathAr": "اسوان"
  },
  {
    "id": "36",
    "en": "Sound and Light Show at Abu Simbel",
    "ar": "العرض الصوت والضوء في أبو سمبل",
    "parentId": "24",
    "path": [
      {
        "id": "24",
        "en": "Aswan",
        "ar": "اسوان"
      }
    ],
    "pathEn": "Aswan",
    "pathAr": "اسوان"
  },
  {
    "id": "37",
    "en": "Unfinished Obelisk",
    "ar": "المسلة الناقصة",
    "parentId": "24",
    "path": [
      {
        "id": "24",
        "en": "Aswan",
        "ar": "اسوان"
      }
    ],
    "pathEn": "Aswan",
    "pathAr": "اسوان"
  },
  {
    "id": "38",
    "en": "Qubbet el-Hawa",
    "ar": "قبة الهوى",
    "parentId": "24",
    "path": [
      {
        "id": "24",
        "en": "Aswan",
        "ar": "اسوان"
      }
    ],
    "pathEn": "Aswan",
    "pathAr": "اسوان"
  },
  {
    "id": "39",
    "en": "Mausoleum of Aga Khan",
    "ar": "مقبرة الأغاخان",
    "parentId": "24",
    "path": [
      {
        "id": "24",
        "en": "Aswan",
        "ar": "اسوان"
      }
    ],
    "pathEn": "Aswan",
    "pathAr": "اسوان"
  },
  {
    "id": "40",
    "en": "Sehel Island",
    "ar": "جزيرة سهيل",
    "parentId": "24",
    "path": [
      {
        "id": "24",
        "en": "Aswan",
        "ar": "اسوان"
      }
    ],
    "pathEn": "Aswan",
    "pathAr": "اسوان"
  },
  {
    "id": "41",
    "en": "New Kalabsha Temple",
    "ar": "معبد كلابشه",
    "parentId": "24",
    "path": [
      {
        "id": "24",
        "en": "Aswan",
        "ar": "اسوان"
      }
    ],
    "pathEn": "Aswan",
    "pathAr": "اسوان"
  },
  {
    "id": "42",
    "en": "Crocodile Museum",
    "ar": "متحف التمساح",
    "parentId": "24",
    "path": [
      {
        "id": "24",
        "en": "Aswan",
        "ar": "اسوان"
      }
    ],
    "pathEn": "Aswan",
    "pathAr": "اسوان"
  },
  {
    "id": "43",
    "en": "Asyut",
    "ar": "أسيوط",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  },
  {
    "id": "44",
    "en": "Meir Tombs",
    "ar": "مقبرة مير",
    "parentId": "43",
    "path": [
      {
        "id": "43",
        "en": "Asyut",
        "ar": "أسيوط"
      }
    ],
    "pathEn": "Asyut",
    "pathAr": "أسيوط"
  },
  {
    "id": "45",
    "en": "Deir Rifa Tombs",
    "ar": "دير ريفا",
    "parentId": "43",
    "path": [
      {
        "id": "43",
        "en": "Asyut",
        "ar": "أسيوط"
      }
    ],
    "pathEn": "Asyut",
    "pathAr": "أسيوط"
  },
  {
    "id": "46",
    "en": "Qussair Al-Amarna Tombs",
    "ar": "مقابر النبلاء",
    "parentId": "43",
    "path": [
      {
        "id": "43",
        "en": "Asyut",
        "ar": "أسيوط"
      }
    ],
    "pathEn": "Asyut",
    "pathAr": "أسيوط"
  },
  {
    "id": "47",
    "en": "Beheira",
    "ar": "البحيرة",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  },
  {
    "id": "48",
    "en": "Africa Safari Park",
    "ar": "أفريكانو بارك",
    "parentId": "47",
    "path": [
      {
        "id": "47",
        "en": "Beheira",
        "ar": "البحيرة"
      }
    ],
    "pathEn": "Beheira",
    "pathAr": "البحيرة"
  },
  {
    "id": "49",
    "en": "Beni Suef",
    "ar": "بني سويف",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  },
  {
    "id": "50",
    "en": "Meidum Pyramid",
    "ar": "هرم ميدوم",
    "parentId": "49",
    "path": [
      {
        "id": "49",
        "en": "Beni Suef",
        "ar": "بني سويف"
      }
    ],
    "pathEn": "Beni Suef",
    "pathAr": "بني سويف"
  },
  {
    "id": "51",
    "en": "Cairo",
    "ar": "القاهرة",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  },
  {
    "id": "52",
    "en": "The Egyptian Museum",
    "ar": "المتحف المصري",
    "parentId": "51",
    "path": [
      {
        "id": "51",
        "en": "Cairo",
        "ar": "القاهرة"
      }
    ],
    "pathEn": "Cairo",
    "pathAr": "القاهرة"
  },
  {
    "id": "53",
    "en": "Nile River",
    "ar": "نهر النيل",
    "parentId": "51",
    "path": [
      {
        "id": "51",
        "en": "Cairo",
        "ar": "القاهرة"
      }
    ],
    "pathEn": "Cairo",
    "pathAr": "القاهرة"
  },
  {
    "id": "54",
    "en": "Khan El-Khalili",
    "ar": "خان الخليلي",
    "parentId": "51",
    "path": [
      {
        "id": "51",
        "en": "Cairo",
        "ar": "القاهرة"
      }
    ],
    "pathEn": "Cairo",
    "pathAr": "القاهرة"
  },
  {
    "id": "55",
    "en": "Coptic Cairo",
    "ar": "القاهرة القبطية",
    "parentId": "51",
    "path": [
      {
        "id": "51",
        "en": "Cairo",
        "ar": "القاهرة"
      }
    ],
    "pathEn": "Cairo",
    "pathAr": "القاهرة"
  },
  {
    "id": "56",
    "en": "Citadel of Saladin",
    "ar": "قلعة صلاح الدين",
    "parentId": "51",
    "path": [
      {
        "id": "51",
        "en": "Cairo",
        "ar": "القاهرة"
      }
    ],
    "pathEn": "Cairo",
    "pathAr": "القاهرة"
  },
  {
    "id": "57",
    "en": "Al-Azhar Park",
    "ar": "حديقة الأزهر",
    "parentId": "51",
    "path": [
      {
        "id": "51",
        "en": "Cairo",
        "ar": "القاهرة"
      }
    ],
    "pathEn": "Cairo",
    "pathAr": "القاهرة"
  },
  {
    "id": "58",
    "en": "Cave Church",
    "ar": "دير سمعان خراز",
    "parentId": "51",
    "path": [
      {
        "id": "51",
        "en": "Cairo",
        "ar": "القاهرة"
      }
    ],
    "pathEn": "Cairo",
    "pathAr": "القاهرة"
  },
  {
    "id": "59",
    "en": "Zamalek",
    "ar": "الزمالك",
    "city": true,
    "parentId": "51",
    "path": [
      {
        "id": "51",
        "en": "Cairo",
        "ar": "القاهرة"
      }
    ],
    "pathEn": "Cairo",
    "pathAr": "القاهرة"
  },
  {
    "id": "60",
    "en": "Cairo Tower",
    "ar": "برج القاهرة",
    "parentId": "59",
    "path": [
      {
        "id": "51",
        "en": "Cairo",
        "ar": "القاهرة"
      },
      {
        "id": "59",
        "en": "Zamalek",
        "ar": "الزمالك"
      }
    ],
    "pathEn": "Cairo > Zamalek",
    "pathAr": "القاهرة > الزمالك"
  },
  {
    "id": "61",
    "en": "National Museum Of Egyptian Civilization",
    "ar": "المتحف القومي للحضارة المصرية",
    "parentId": "51",
    "path": [
      {
        "id": "51",
        "en": "Cairo",
        "ar": "القاهرة"
      }
    ],
    "pathEn": "Cairo",
    "pathAr": "القاهرة"
  },
  {
    "id": "62",
    "en": "The Handing Church",
    "ar": "الكنيسة المعلقة",
    "parentId": "51",
    "path": [
      {
        "id": "51",
        "en": "Cairo",
        "ar": "القاهرة"
      }
    ],
    "pathEn": "Cairo",
    "pathAr": "القاهرة"
  },
  {
    "id": "63",
    "en": "Islamic Cairo",
    "ar": "القاهرة الاسلامية",
    "parentId": "51",
    "path": [
      {
        "id": "51",
        "en": "Cairo",
        "ar": "القاهرة"
      }
    ],
    "pathEn": "Cairo",
    "pathAr": "القاهرة"
  },
  {
    "id": "64",
    "en": "Al-Azhar Mosque",
    "ar": "مسجد الازهر",
    "parentId": "51",
    "path": [
      {
        "id": "51",
        "en": "Cairo",
        "ar": "القاهرة"
      }
    ],
    "pathEn": "Cairo",
    "pathAr": "القاهرة"
  },
  {
    "id": "65",
    "en": "Al-Moez Street",
    "ar": "شارع المعز",
    "parentId": "51",
    "path": [
      {
        "id": "51",
        "en": "Cairo",
        "ar": "القاهرة"
      }
    ],
    "pathEn": "Cairo",
    "pathAr": "القاهرة"
  },
  {
    "id": "66",
    "en": "Mosque of Sultan Al-Hassan",
    "ar": "مسجد السلطان حسن",
    "parentId": "51",
    "path": [
      {
        "id": "51",
        "en": "Cairo",
        "ar": "القاهرة"
      }
    ],
    "pathEn": "Cairo",
    "pathAr": "القاهرة"
  },
  {
    "id": "67",
    "en": "Mosque of Ibn Tulun",
    "ar": "مسجد بن طولون",
    "parentId": "51",
    "path": [
      {
        "id": "51",
        "en": "Cairo",
        "ar": "القاهرة"
      }
    ],
    "pathEn": "Cairo",
    "pathAr": "القاهرة"
  },
  {
    "id": "68",
    "en": "The Coptic Museum",
    "ar": "المتحف القبطى",
    "parentId": "51",
    "path": [
      {
        "id": "51",
        "en": "Cairo",
        "ar": "القاهرة"
      }
    ],
    "pathEn": "Cairo",
    "pathAr": "القاهرة"
  },
  {
    "id": "69",
    "en": "Museum of Islamic Arts",
    "ar": "متحف الفن الإسلامي",
    "parentId": "51",
    "path": [
      {
        "id": "51",
        "en": "Cairo",
        "ar": "القاهرة"
      }
    ],
    "pathEn": "Cairo",
    "pathAr": "القاهرة"
  },
  {
    "id": "70",
    "en": "Manial Palace",
    "ar": "قصر المنيل",
    "parentId": "51",
    "path": [
      {
        "id": "51",
        "en": "Cairo",
        "ar": "القاهرة"
      }
    ],
    "pathEn": "Cairo",
    "pathAr": "القاهرة"
  },
  {
    "id": "71",
    "en": "Wekalet El Ghouri",
    "ar": "وكالة الغورى",
    "parentId": "51",
    "path": [
      {
        "id": "51",
        "en": "Cairo",
        "ar": "القاهرة"
      }
    ],
    "pathEn": "Cairo",
    "pathAr": "القاهرة"
  },
  {
    "id": "72",
    "en": "Dakahlia",
    "ar": "الدقهلية",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  },
  {
    "id": "73",
    "en": "Damietta",
    "ar": "دمياط",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  },
  {
    "id": "74",
    "en": "Faiyum",
    "ar": "الفيوم",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  },
  {
    "id": "75",
    "en": "Wadi El-Rayan",
    "ar": "وادي الريان",
    "parentId": "74",
    "path": [
      {
        "id": "74",
        "en": "Faiyum",
        "ar": "الفيوم"
      }
    ],
    "pathEn": "Faiyum",
    "pathAr": "الفيوم"
  },
  {
    "id": "76",
    "en": "Fayoum Oasis",
    "ar": "واحة الفيوم",
    "parentId": "74",
    "path": [
      {
        "id": "74",
        "en": "Faiyum",
        "ar": "الفيوم"
      }
    ],
    "pathEn": "Faiyum",
    "pathAr": "الفيوم"
  },
  {
    "id": "77",
    "en": "The Pyramid of Sneferu",
    "ar": "هرم سنفرو",
    "parentId": "74",
    "path": [
      {
        "id": "74",
        "en": "Faiyum",
        "ar": "الفيوم"
      }
    ],
    "pathEn": "Faiyum",
    "pathAr": "الفيوم"
  },
  {
    "id": "78",
    "en": "Hawara Pyramid",
    "ar": "هرم هوارة",
    "parentId": "74",
    "path": [
      {
        "id": "74",
        "en": "Faiyum",
        "ar": "الفيوم"
      }
    ],
    "pathEn": "Faiyum",
    "pathAr": "الفيوم"
  },
  {
    "id": "79",
    "en": "Lahun Pyramid",
    "ar": "هرم اللاهون",
    "parentId": "74",
    "path": [
      {
        "id": "74",
        "en": "Faiyum",
        "ar": "الفيوم"
      }
    ],
    "pathEn": "Faiyum",
    "pathAr": "الفيوم"
  },
  {
    "id": "80",
    "en": "Qasr Qarun",
    "ar": "قصر قارون",
    "parentId": "74",
    "path": [
      {
        "id": "74",
        "en": "Faiyum",
        "ar": "الفيوم"
      }
    ],
    "pathEn": "Faiyum",
    "pathAr": "الفيوم"
  },
  {
    "id": "81",
    "en": "Waterwheels",
    "ar": "سواقي الفيوم",
    "parentId": "74",
    "path": [
      {
        "id": "74",
        "en": "Faiyum",
        "ar": "الفيوم"
      }
    ],
    "pathEn": "Faiyum",
    "pathAr": "الفيوم"
  },
  {
    "id": "82",
    "en": "Tunis Village",
    "ar": "قرية تونس",
    "parentId": "74",
    "path": [
      {
        "id": "74",
        "en": "Faiyum",
        "ar": "الفيوم"
      }
    ],
    "pathEn": "Faiyum",
    "pathAr": "الفيوم"
  },
  {
    "id": "83",
    "en": "Gharbia",
    "ar": "الغربية",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  },
  {
    "id": "84",
    "en": "Giza",
    "ar": "الجيزة",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  },
  {
    "id": "85",
    "en": "Pyramids of Giza",
    "ar": "الاهرامات",
    "parentId": "84",
    "path": [
      {
        "id": "84",
        "en": "Giza",
        "ar": "الجيزة"
      }
    ],
    "pathEn": "Giza",
    "pathAr": "الجيزة"
  },
  {
    "id": "86",
    "en": "Saqqara Necropolis",
    "ar": "سقارة",
    "parentId": "84",
    "path": [
      {
        "id": "84",
        "en": "Giza",
        "ar": "الجيزة"
      }
    ],
    "pathEn": "Giza",
    "pathAr": "الجيزة"
  },
  {
    "id": "87",
    "en": "Dahshour Necropolis",
    "ar": "دهشور",
    "parentId": "84",
    "path": [
      {
        "id": "84",
        "en": "Giza",
        "ar": "الجيزة"
      }
    ],
    "pathEn": "Giza",
    "pathAr": "الجيزة"
  },
  {
    "id": "88",
    "en": "Pharaonic Village",
    "ar": "القرية الفرعونية",
    "parentId": "84",
    "path": [
      {
        "id": "84",
        "en": "Giza",
        "ar": "الجيزة"
      }
    ],
    "pathEn": "Giza",
    "pathAr": "الجيزة"
  },
  {
    "id": "89",
    "en": "Pyramid of Djoser",
    "ar": "هرم زوسر",
    "parentId": "84",
    "path": [
      {
        "id": "84",
        "en": "Giza",
        "ar": "الجيزة"
      }
    ],
    "pathEn": "Giza",
    "pathAr": "الجيزة"
  },
  {
    "id": "90",
    "en": "Wadi El-Hitan",
    "ar": "وادي الحيتان",
    "parentId": "84",
    "path": [
      {
        "id": "84",
        "en": "Giza",
        "ar": "الجيزة"
      }
    ],
    "pathEn": "Giza",
    "pathAr": "الجيزة"
  },
  {
    "id": "91",
    "en": "Grand Egyptian Museum",
    "ar": "المتحف المصري الكبير",
    "parentId": "84",
    "path": [
      {
        "id": "84",
        "en": "Giza",
        "ar": "الجيزة"
      }
    ],
    "pathEn": "Giza",
    "pathAr": "الجيزة"
  },
  {
    "id": "92",
    "en": "Dream Park",
    "ar": "دريم بارك",
    "parentId": "84",
    "path": [
      {
        "id": "84",
        "en": "Giza",
        "ar": "الجيزة"
      }
    ],
    "pathEn": "Giza",
    "pathAr": "الجيزة"
  },
  {
    "id": "93",
    "en": "Mastaba of Ti",
    "ar": "مصطبة تي",
    "parentId": "84",
    "path": [
      {
        "id": "84",
        "en": "Giza",
        "ar": "الجيزة"
      }
    ],
    "pathEn": "Giza",
    "pathAr": "الجيزة"
  },
  {
    "id": "94",
    "en": "Ramses Wissa Wassef Art Centre",
    "ar": "مركز رمسيس ويصا واصف",
    "parentId": "84",
    "path": [
      {
        "id": "84",
        "en": "Giza",
        "ar": "الجيزة"
      }
    ],
    "pathEn": "Giza",
    "pathAr": "الجيزة"
  },
  {
    "id": "95",
    "en": "Bahariya Oasis",
    "ar": "الواحات البحرية",
    "parentId": "84",
    "path": [
      {
        "id": "84",
        "en": "Giza",
        "ar": "الجيزة"
      }
    ],
    "pathEn": "Giza",
    "pathAr": "الجيزة"
  },
  {
    "id": "96",
    "en": "Egypt Papyrus Museum",
    "ar": "المتحف الفرعوني للبرديات",
    "parentId": "84",
    "path": [
      {
        "id": "84",
        "en": "Giza",
        "ar": "الجيزة"
      }
    ],
    "pathEn": "Giza",
    "pathAr": "الجيزة"
  },
  {
    "id": "97",
    "en": "Ismailia",
    "ar": "الإسماعيلية",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  },
  {
    "id": "98",
    "en": "Ismailia Museum",
    "ar": "متحف أثار الإسماعيلية",
    "parentId": "97",
    "path": [
      {
        "id": "97",
        "en": "Ismailia",
        "ar": "الإسماعيلية"
      }
    ],
    "pathEn": "Ismailia",
    "pathAr": "الإسماعيلية"
  },
  {
    "id": "99",
    "en": "Kafr El Sheikh",
    "ar": "كفر الشيخ",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  },
  {
    "id": "100",
    "en": "Luxor",
    "ar": "الأقصر",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  },
  {
    "id": "101",
    "en": "Valley of the Kings",
    "ar": "وادي الملوك",
    "parentId": "100",
    "path": [
      {
        "id": "100",
        "en": "Luxor",
        "ar": "الأقصر"
      }
    ],
    "pathEn": "Luxor",
    "pathAr": "الأقصر"
  },
  {
    "id": "102",
    "en": "Temple of Karnak",
    "ar": "معبد الكرنك",
    "parentId": "100",
    "path": [
      {
        "id": "100",
        "en": "Luxor",
        "ar": "الأقصر"
      }
    ],
    "pathEn": "Luxor",
    "pathAr": "الأقصر"
  },
  {
    "id": "103",
    "en": "Temple of Hatshepsut",
    "ar": "معبد حتشبسوت",
    "parentId": "100",
    "path": [
      {
        "id": "100",
        "en": "Luxor",
        "ar": "الأقصر"
      }
    ],
    "pathEn": "Luxor",
    "pathAr": "الأقصر"
  },
  {
    "id": "104",
    "en": "Luxor Museum",
    "ar": "متحف الأقصر",
    "parentId": "100",
    "path": [
      {
        "id": "100",
        "en": "Luxor",
        "ar": "الأقصر"
      }
    ],
    "pathEn": "Luxor",
    "pathAr": "الأقصر"
  },
  {
    "id": "105",
    "en": "Tomb of King Tutankhamun",
    "ar": "مقبرة توت عنخ آمون",
    "parentId": "100",
    "path": [
      {
        "id": "100",
        "en": "Luxor",
        "ar": "الأقصر"
      }
    ],
    "pathEn": "Luxor",
    "pathAr": "الأقصر"
  },
  {
    "id": "106",
    "en": "Tomb of Queen Nefertari",
    "ar": "مقبرة نفرتاري",
    "parentId": "100",
    "path": [
      {
        "id": "100",
        "en": "Luxor",
        "ar": "الأقصر"
      }
    ],
    "pathEn": "Luxor",
    "pathAr": "الأقصر"
  },
  {
    "id": "107",
    "en": "Avenue of Sphinxes",
    "ar": "طريق الكباش",
    "parentId": "100",
    "path": [
      {
        "id": "100",
        "en": "Luxor",
        "ar": "الأقصر"
      }
    ],
    "pathEn": "Luxor",
    "pathAr": "الأقصر"
  },
  {
    "id": "108",
    "en": "Luxor Market",
    "ar": "سوق الاقصر",
    "parentId": "100",
    "path": [
      {
        "id": "100",
        "en": "Luxor",
        "ar": "الأقصر"
      }
    ],
    "pathEn": "Luxor",
    "pathAr": "الأقصر"
  },
  {
    "id": "109",
    "en": "Colossi of Memnon",
    "ar": "تمثالين ممنون",
    "parentId": "100",
    "path": [
      {
        "id": "100",
        "en": "Luxor",
        "ar": "الأقصر"
      }
    ],
    "pathEn": "Luxor",
    "pathAr": "الأقصر"
  },
  {
    "id": "110",
    "en": "Tomb of Ramses VI",
    "ar": "مقبرة رمسيس السادس",
    "parentId": "100",
    "path": [
      {
        "id": "100",
        "en": "Luxor",
        "ar": "الأقصر"
      }
    ],
    "pathEn": "Luxor",
    "pathAr": "الأقصر"
  },
  {
    "id": "111",
    "en": "Valley of the Artisans",
    "ar": "دير المدينة",
    "parentId": "100",
    "path": [
      {
        "id": "100",
        "en": "Luxor",
        "ar": "الأقصر"
      }
    ],
    "pathEn": "Luxor",
    "pathAr": "الأقصر"
  },
  {
    "id": "112",
    "en": "Luxor Sound and Light Show",
    "ar": "عرض الصوت والضوء في معبد الكرنك",
    "parentId": "100",
    "path": [
      {
        "id": "100",
        "en": "Luxor",
        "ar": "الأقصر"
      }
    ],
    "pathEn": "Luxor",
    "pathAr": "الأقصر"
  },
  {
    "id": "113",
    "en": "Howard Carter House",
    "ar": "بيت هوارد كارتر",
    "parentId": "100",
    "path": [
      {
        "id": "100",
        "en": "Luxor",
        "ar": "الأقصر"
      }
    ],
    "pathEn": "Luxor",
    "pathAr": "الأقصر"
  },
  {
    "id": "114",
    "en": "Tomb of Ramses III",
    "ar": "مقبرة رمسيس الثالث",
    "parentId": "100",
    "path": [
      {
        "id": "100",
        "en": "Luxor",
        "ar": "الأقصر"
      }
    ],
    "pathEn": "Luxor",
    "pathAr": "الأقصر"
  },
  {
    "id": "115",
    "en": "Mummification Museum",
    "ar": "متحف التحنيط",
    "parentId": "100",
    "path": [
      {
        "id": "100",
        "en": "Luxor",
        "ar": "الأقصر"
      }
    ],
    "pathEn": "Luxor",
    "pathAr": "الأقصر"
  },
  {
    "id": "116",
    "en": "Ramesseum",
    "ar": "الرامسيوم",
    "parentId": "100",
    "path": [
      {
        "id": "100",
        "en": "Luxor",
        "ar": "الأقصر"
      }
    ],
    "pathEn": "Luxor",
    "pathAr": "الأقصر"
  },
  {
    "id": "117",
    "en": "Corniche",
    "ar": "كورنيش الأقصر",
    "parentId": "100",
    "path": [
      {
        "id": "100",
        "en": "Luxor",
        "ar": "الأقصر"
      }
    ],
    "pathEn": "Luxor",
    "pathAr": "الأقصر"
  },
  {
    "id": "118",
    "en": "Valle Delle Regine",
    "ar": "وادي الملكات",
    "parentId": "100",
    "path": [
      {
        "id": "100",
        "en": "Luxor",
        "ar": "الأقصر"
      }
    ],
    "pathEn": "Luxor",
    "pathAr": "الأقصر"
  },
  {
    "id": "119",
    "en": "Karnak Open Air Museum",
    "ar": "متحف الكرنك المفتوح",
    "parentId": "100",
    "path": [
      {
        "id": "100",
        "en": "Luxor",
        "ar": "الأقصر"
      }
    ],
    "pathEn": "Luxor",
    "pathAr": "الأقصر"
  },
  {
    "id": "120",
    "en": "Obelisk of Thutmoses I",
    "ar": "مسلة تحتمس الأول",
    "parentId": "100",
    "path": [
      {
        "id": "100",
        "en": "Luxor",
        "ar": "الأقصر"
      }
    ],
    "pathEn": "Luxor",
    "pathAr": "الأقصر"
  },
  {
    "id": "121",
    "en": "Tomb of Merenptah",
    "ar": "مقبرة مرنبتاح",
    "parentId": "100",
    "path": [
      {
        "id": "100",
        "en": "Luxor",
        "ar": "الأقصر"
      }
    ],
    "pathEn": "Luxor",
    "pathAr": "الأقصر"
  },
  {
    "id": "122",
    "en": "Tomb of Ramses IV",
    "ar": "مقبرة رمسيس الرابع",
    "parentId": "100",
    "path": [
      {
        "id": "100",
        "en": "Luxor",
        "ar": "الأقصر"
      }
    ],
    "pathEn": "Luxor",
    "pathAr": "الأقصر"
  },
  {
    "id": "123",
    "en": "Tomb of Ay",
    "ar": "مقبرة آي",
    "parentId": "100",
    "path": [
      {
        "id": "100",
        "en": "Luxor",
        "ar": "الأقصر"
      }
    ],
    "pathEn": "Luxor",
    "pathAr": "الأقصر"
  },
  {
    "id": "124",
    "en": "Matrouh",
    "ar": "مطروح",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  },
  {
    "id": "125",
    "en": "Almaza Bay",
    "ar": "الماظة باي",
    "parentId": "124",
    "path": [
      {
        "id": "124",
        "en": "Matrouh",
        "ar": "مطروح"
      }
    ],
    "pathEn": "Matrouh",
    "pathAr": "مطروح"
  },
  {
    "id": "126",
    "en": "Siwa Oasis",
    "ar": "سيوة",
    "city": true,
    "parentId": "124",
    "path": [
      {
        "id": "124",
        "en": "Matrouh",
        "ar": "مطروح"
      }
    ],
    "pathEn": "Matrouh",
    "pathAr": "مطروح"
  },
  {
    "id": "127",
    "en": "Temple of Umm Ubayd",
    "ar": "معبد أم عبيدة",
    "parentId": "126",
    "path": [
      {
        "id": "124",
        "en": "Matrouh",
        "ar": "مطروح"
      },
      {
        "id": "126",
        "en": "Siwa Oasis",
        "ar": "سيوة"
      }
    ],
    "pathEn": "Matrouh > Siwa Oasis",
    "pathAr": "مطروح > سيوة"
  },
  {
    "id": "128",
    "en": "Shali Fortress",
    "ar": "قلعة شالي",
    "parentId": "126",
    "path": [
      {
        "id": "124",
        "en": "Matrouh",
        "ar": "مطروح"
      },
      {
        "id": "126",
        "en": "Siwa Oasis",
        "ar": "سيوة"
      }
    ],
    "pathEn": "Matrouh > Siwa Oasis",
    "pathAr": "مطروح > سيوة"
  },
  {
    "id": "129",
    "en": "Fatnis Island",
    "ar": "جزيرة فطناس",
    "parentId": "126",
    "path": [
      {
        "id": "124",
        "en": "Matrouh",
        "ar": "مطروح"
      },
      {
        "id": "126",
        "en": "Siwa Oasis",
        "ar": "سيوة"
      }
    ],
    "pathEn": "Matrouh > Siwa Oasis",
    "pathAr": "مطروح > سيوة"
  },
  {
    "id": "130",
    "en": "Mountain of the Dead",
    "ar": "جبل الموتى",
    "parentId": "126",
    "path": [
      {
        "id": "124",
        "en": "Matrouh",
        "ar": "مطروح"
      },
      {
        "id": "126",
        "en": "Siwa Oasis",
        "ar": "سيوة"
      }
    ],
    "pathEn": "Matrouh > Siwa Oasis",
    "pathAr": "مطروح > سيوة"
  },
  {
    "id": "131",
    "en": "Cleopatra's Pool",
    "ar": "حمام كليوباترا",
    "parentId": "126",
    "path": [
      {
        "id": "124",
        "en": "Matrouh",
        "ar": "مطروح"
      },
      {
        "id": "126",
        "en": "Siwa Oasis",
        "ar": "سيوة"
      }
    ],
    "pathEn": "Matrouh > Siwa Oasis",
    "pathAr": "مطروح > سيوة"
  },
  {
    "id": "132",
    "en": "Amun Temple",
    "ar": "معبد امون",
    "parentId": "126",
    "path": [
      {
        "id": "124",
        "en": "Matrouh",
        "ar": "مطروح"
      },
      {
        "id": "126",
        "en": "Siwa Oasis",
        "ar": "سيوة"
      }
    ],
    "pathEn": "Matrouh > Siwa Oasis",
    "pathAr": "مطروح > سيوة"
  },
  {
    "id": "133",
    "en": "Salt Lakes",
    "ar": "بحيرات الملح",
    "parentId": "126",
    "path": [
      {
        "id": "124",
        "en": "Matrouh",
        "ar": "مطروح"
      },
      {
        "id": "126",
        "en": "Siwa Oasis",
        "ar": "سيوة"
      }
    ],
    "pathEn": "Matrouh > Siwa Oasis",
    "pathAr": "مطروح > سيوة"
  },
  {
    "id": "134",
    "en": "Al Alamein War Cemetery",
    "ar": "مقابر العلمين",
    "parentId": "124",
    "path": [
      {
        "id": "124",
        "en": "Matrouh",
        "ar": "مطروح"
      }
    ],
    "pathEn": "Matrouh",
    "pathAr": "مطروح"
  },
  {
    "id": "135",
    "en": "Corniche",
    "ar": "كورنيش العلمين",
    "parentId": "124",
    "path": [
      {
        "id": "124",
        "en": "Matrouh",
        "ar": "مطروح"
      }
    ],
    "pathEn": "Matrouh",
    "pathAr": "مطروح"
  },
  {
    "id": "136",
    "en": "Al Alamein War Museum",
    "ar": "متحف العلمين العسكري",
    "parentId": "124",
    "path": [
      {
        "id": "124",
        "en": "Matrouh",
        "ar": "مطروح"
      }
    ],
    "pathEn": "Matrouh",
    "pathAr": "مطروح"
  },
  {
    "id": "137",
    "en": "Deutsche Kriegsgraeberstatte",
    "ar": "المقبرة الألمانية",
    "parentId": "124",
    "path": [
      {
        "id": "124",
        "en": "Matrouh",
        "ar": "مطروح"
      }
    ],
    "pathEn": "Matrouh",
    "pathAr": "مطروح"
  },
  {
    "id": "138",
    "en": "Sacrario Militare Italiano",
    "ar": "المقبرة الإيطالية",
    "parentId": "124",
    "path": [
      {
        "id": "124",
        "en": "Matrouh",
        "ar": "مطروح"
      }
    ],
    "pathEn": "Matrouh",
    "pathAr": "مطروح"
  },
  {
    "id": "139",
    "en": "Minya",
    "ar": "المنيا",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  },
  {
    "id": "140",
    "en": "Tuna el-Gebel",
    "ar": "تونة الجبل",
    "parentId": "139",
    "path": [
      {
        "id": "139",
        "en": "Minya",
        "ar": "المنيا"
      }
    ],
    "pathEn": "Minya",
    "pathAr": "المنيا"
  },
  {
    "id": "141",
    "en": "Tell el-Amarna",
    "ar": "تل العمارنة",
    "parentId": "139",
    "path": [
      {
        "id": "139",
        "en": "Minya",
        "ar": "المنيا"
      }
    ],
    "pathEn": "Minya",
    "pathAr": "المنيا"
  },
  {
    "id": "142",
    "en": "Beni Hassan",
    "ar": "مقابر بني حسن",
    "parentId": "139",
    "path": [
      {
        "id": "139",
        "en": "Minya",
        "ar": "المنيا"
      }
    ],
    "pathEn": "Minya",
    "pathAr": "المنيا"
  },
  {
    "id": "143",
    "en": "Monufia",
    "ar": "المنوفية",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  },
  {
    "id": "144",
    "en": "New Valley",
    "ar": "الوادي الجديد",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  },
  {
    "id": "145",
    "en": "White Desert",
    "ar": "الصحراء البيضاء",
    "parentId": "144",
    "path": [
      {
        "id": "144",
        "en": "New Valley",
        "ar": "الوادي الجديد"
      }
    ],
    "pathEn": "New Valley",
    "pathAr": "الوادي الجديد"
  },
  {
    "id": "146",
    "en": "Dakhla Oasis",
    "ar": "واحة الداخلة",
    "parentId": "144",
    "path": [
      {
        "id": "144",
        "en": "New Valley",
        "ar": "الوادي الجديد"
      }
    ],
    "pathEn": "New Valley",
    "pathAr": "الوادي الجديد"
  },
  {
    "id": "147",
    "en": "Valley of Agabat",
    "ar": "وادي العقبات",
    "parentId": "144",
    "path": [
      {
        "id": "144",
        "en": "New Valley",
        "ar": "الوادي الجديد"
      }
    ],
    "pathEn": "New Valley",
    "pathAr": "الوادي الجديد"
  },
  {
    "id": "148",
    "en": "Tombs of the Nobles",
    "ar": "مقابر النبلاء",
    "parentId": "144",
    "path": [
      {
        "id": "144",
        "en": "New Valley",
        "ar": "الوادي الجديد"
      }
    ],
    "pathEn": "New Valley",
    "pathAr": "الوادي الجديد"
  },
  {
    "id": "149",
    "en": "Necropolis of Al-Bagawat",
    "ar": "البجوات",
    "parentId": "144",
    "path": [
      {
        "id": "144",
        "en": "New Valley",
        "ar": "الوادي الجديد"
      }
    ],
    "pathEn": "New Valley",
    "pathAr": "الوادي الجديد"
  },
  {
    "id": "150",
    "en": "Badr's Museum",
    "ar": "متحف بدر",
    "parentId": "144",
    "path": [
      {
        "id": "144",
        "en": "New Valley",
        "ar": "الوادي الجديد"
      }
    ],
    "pathEn": "New Valley",
    "pathAr": "الوادي الجديد"
  },
  {
    "id": "151",
    "en": "Sinai & Red Sea",
    "ar": "سيناء والبحر الاحمر",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  },
  {
    "id": "152",
    "en": "Ain Shokhna",
    "ar": "العين السخنة",
    "city": true,
    "parentId": "151",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      }
    ],
    "pathEn": "Sinai & Red Sea",
    "pathAr": "سيناء والبحر الاحمر"
  },
  {
    "id": "153",
    "en": "Hurgada",
    "ar": "الغردقة",
    "city": true,
    "parentId": "151",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      }
    ],
    "pathEn": "Sinai & Red Sea",
    "pathAr": "سيناء والبحر الاحمر"
  },
  {
    "id": "154",
    "en": "Mahmya Island",
    "ar": "محمية",
    "parentId": "153",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      },
      {
        "id": "153",
        "en": "Hurgada",
        "ar": "الغردقة"
      }
    ],
    "pathEn": "Sinai & Red Sea > Hurgada",
    "pathAr": "سيناء والبحر الاحمر > الغردقة"
  },
  {
    "id": "155",
    "en": "Jungle Aqua Park",
    "ar": "جنغل أكوا بارك",
    "parentId": "153",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      },
      {
        "id": "153",
        "en": "Hurgada",
        "ar": "الغردقة"
      }
    ],
    "pathEn": "Sinai & Red Sea > Hurgada",
    "pathAr": "سيناء والبحر الاحمر > الغردقة"
  },
  {
    "id": "156",
    "en": "Giftun Islands",
    "ar": "جزر الجفتون",
    "parentId": "153",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      },
      {
        "id": "153",
        "en": "Hurgada",
        "ar": "الغردقة"
      }
    ],
    "pathEn": "Sinai & Red Sea > Hurgada",
    "pathAr": "سيناء والبحر الاحمر > الغردقة"
  },
  {
    "id": "157",
    "en": "Makadi Water World",
    "ar": "مكادي وتر ورلد",
    "parentId": "153",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      },
      {
        "id": "153",
        "en": "Hurgada",
        "ar": "الغردقة"
      }
    ],
    "pathEn": "Sinai & Red Sea > Hurgada",
    "pathAr": "سيناء والبحر الاحمر > الغردقة"
  },
  {
    "id": "158",
    "en": "Mini Egypt Park",
    "ar": "مينى ايجيبت بارك",
    "parentId": "153",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      },
      {
        "id": "153",
        "en": "Hurgada",
        "ar": "الغردقة"
      }
    ],
    "pathEn": "Sinai & Red Sea > Hurgada",
    "pathAr": "سيناء والبحر الاحمر > الغردقة"
  },
  {
    "id": "159",
    "en": "Dolphin House",
    "ar": "بيت الدلافين",
    "parentId": "153",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      },
      {
        "id": "153",
        "en": "Hurgada",
        "ar": "الغردقة"
      }
    ],
    "pathEn": "Sinai & Red Sea > Hurgada",
    "pathAr": "سيناء والبحر الاحمر > الغردقة"
  },
  {
    "id": "160",
    "en": "El Mina Mosque",
    "ar": "مسجد الميناء",
    "parentId": "153",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      },
      {
        "id": "153",
        "en": "Hurgada",
        "ar": "الغردقة"
      }
    ],
    "pathEn": "Sinai & Red Sea > Hurgada",
    "pathAr": "سيناء والبحر الاحمر > الغردقة"
  },
  {
    "id": "161",
    "en": "Sindbad Aqua Park",
    "ar": "سندباد اكوا بارك",
    "parentId": "153",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      },
      {
        "id": "153",
        "en": "Hurgada",
        "ar": "الغردقة"
      }
    ],
    "pathEn": "Sinai & Red Sea > Hurgada",
    "pathAr": "سيناء والبحر الاحمر > الغردقة"
  },
  {
    "id": "162",
    "en": "Sharm El-Luli",
    "ar": "شرم اللولي",
    "city": true,
    "parentId": "151",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      }
    ],
    "pathEn": "Sinai & Red Sea",
    "pathAr": "سيناء والبحر الاحمر"
  },
  {
    "id": "163",
    "en": "El Gouna",
    "ar": "الجونة",
    "city": true,
    "parentId": "151",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      }
    ],
    "pathEn": "Sinai & Red Sea",
    "pathAr": "سيناء والبحر الاحمر"
  },
  {
    "id": "164",
    "en": "Marsa Alam",
    "ar": "مرسى علم",
    "city": true,
    "parentId": "151",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      }
    ],
    "pathEn": "Sinai & Red Sea",
    "pathAr": "سيناء والبحر الاحمر"
  },
  {
    "id": "165",
    "en": "Wadi El Gemal",
    "ar": "وادي الجمال",
    "parentId": "164",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      },
      {
        "id": "164",
        "en": "Marsa Alam",
        "ar": "مرسى علم"
      }
    ],
    "pathEn": "Sinai & Red Sea > Marsa Alam",
    "pathAr": "سيناء والبحر الاحمر > مرسى علم"
  },
  {
    "id": "166",
    "en": "Elphinstone Reef",
    "ar": "شعاب الفينستون",
    "parentId": "164",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      },
      {
        "id": "164",
        "en": "Marsa Alam",
        "ar": "مرسى علم"
      }
    ],
    "pathEn": "Sinai & Red Sea > Marsa Alam",
    "pathAr": "سيناء والبحر الاحمر > مرسى علم"
  },
  {
    "id": "167",
    "en": "Shalateen",
    "ar": "شلاتين",
    "city": true,
    "parentId": "151",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      }
    ],
    "pathEn": "Sinai & Red Sea",
    "pathAr": "سيناء والبحر الاحمر"
  },
  {
    "id": "168",
    "en": "Halayeb",
    "ar": "حلايب",
    "city": true,
    "parentId": "151",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      }
    ],
    "pathEn": "Sinai & Red Sea",
    "pathAr": "سيناء والبحر الاحمر"
  },
  {
    "id": "169",
    "en": "Al Quseer",
    "ar": "القصير",
    "city": true,
    "parentId": "151",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      }
    ],
    "pathEn": "Sinai & Red Sea",
    "pathAr": "سيناء والبحر الاحمر"
  },
  {
    "id": "170",
    "en": "Safaga",
    "ar": "سفاجا",
    "city": true,
    "parentId": "151",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      }
    ],
    "pathEn": "Sinai & Red Sea",
    "pathAr": "سيناء والبحر الاحمر"
  },
  {
    "id": "171",
    "en": "Ras Sedr",
    "ar": "راس سدر",
    "city": true,
    "parentId": "151",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      }
    ],
    "pathEn": "Sinai & Red Sea",
    "pathAr": "سيناء والبحر الاحمر"
  },
  {
    "id": "172",
    "en": "Ras Abu Rudeis",
    "ar": "راس أبو رديس",
    "city": true,
    "parentId": "151",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      }
    ],
    "pathEn": "Sinai & Red Sea",
    "pathAr": "سيناء والبحر الاحمر"
  },
  {
    "id": "173",
    "en": "El Tor",
    "ar": "الطور",
    "city": true,
    "parentId": "151",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      }
    ],
    "pathEn": "Sinai & Red Sea",
    "pathAr": "سيناء والبحر الاحمر"
  },
  {
    "id": "174",
    "en": "Sharm El-Sheikh",
    "ar": "شرم الشيخ",
    "city": true,
    "parentId": "151",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      }
    ],
    "pathEn": "Sinai & Red Sea",
    "pathAr": "سيناء والبحر الاحمر"
  },
  {
    "id": "175",
    "en": "Shark's Bay",
    "ar": "خليج القرش",
    "parentId": "174",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      },
      {
        "id": "174",
        "en": "Sharm El-Sheikh",
        "ar": "شرم الشيخ"
      }
    ],
    "pathEn": "Sinai & Red Sea > Sharm El-Sheikh",
    "pathAr": "سيناء والبحر الاحمر > شرم الشيخ"
  },
  {
    "id": "176",
    "en": "El Fanar",
    "ar": "الفنار",
    "parentId": "174",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      },
      {
        "id": "174",
        "en": "Sharm El-Sheikh",
        "ar": "شرم الشيخ"
      }
    ],
    "pathEn": "Sinai & Red Sea > Sharm El-Sheikh",
    "pathAr": "سيناء والبحر الاحمر > شرم الشيخ"
  },
  {
    "id": "177",
    "en": "The Heavenly Cathedral",
    "ar": "الكاتدرائية السماوية",
    "parentId": "174",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      },
      {
        "id": "174",
        "en": "Sharm El-Sheikh",
        "ar": "شرم الشيخ"
      }
    ],
    "pathEn": "Sinai & Red Sea > Sharm El-Sheikh",
    "pathAr": "سيناء والبحر الاحمر > شرم الشيخ"
  },
  {
    "id": "178",
    "en": "Al Sahaba Mosque",
    "ar": "مسجد الصحابة",
    "parentId": "174",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      },
      {
        "id": "174",
        "en": "Sharm El-Sheikh",
        "ar": "شرم الشيخ"
      }
    ],
    "pathEn": "Sinai & Red Sea > Sharm El-Sheikh",
    "pathAr": "سيناء والبحر الاحمر > شرم الشيخ"
  },
  {
    "id": "179",
    "en": "SOHO Square",
    "ar": "سوهو سكوير",
    "parentId": "174",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      },
      {
        "id": "174",
        "en": "Sharm El-Sheikh",
        "ar": "شرم الشيخ"
      }
    ],
    "pathEn": "Sinai & Red Sea > Sharm El-Sheikh",
    "pathAr": "سيناء والبحر الاحمر > شرم الشيخ"
  },
  {
    "id": "180",
    "en": "Al Mustafa Mosque",
    "ar": "مسجد المصطفى",
    "parentId": "174",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      },
      {
        "id": "174",
        "en": "Sharm El-Sheikh",
        "ar": "شرم الشيخ"
      }
    ],
    "pathEn": "Sinai & Red Sea > Sharm El-Sheikh",
    "pathAr": "سيناء والبحر الاحمر > شرم الشيخ"
  },
  {
    "id": "181",
    "en": "Ras Mohammed",
    "ar": "راس محمد",
    "city": true,
    "parentId": "151",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      }
    ],
    "pathEn": "Sinai & Red Sea",
    "pathAr": "سيناء والبحر الاحمر"
  },
  {
    "id": "182",
    "en": "Dahab",
    "ar": "دهب",
    "city": true,
    "parentId": "151",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      }
    ],
    "pathEn": "Sinai & Red Sea",
    "pathAr": "سيناء والبحر الاحمر"
  },
  {
    "id": "183",
    "en": "Blue Hole",
    "ar": "بلو هول",
    "parentId": "182",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      },
      {
        "id": "182",
        "en": "Dahab",
        "ar": "دهب"
      }
    ],
    "pathEn": "Sinai & Red Sea > Dahab",
    "pathAr": "سيناء والبحر الاحمر > دهب"
  },
  {
    "id": "184",
    "en": "Neweiba",
    "ar": "نويبع",
    "city": true,
    "parentId": "151",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      }
    ],
    "pathEn": "Sinai & Red Sea",
    "pathAr": "سيناء والبحر الاحمر"
  },
  {
    "id": "185",
    "en": "Mount Sinai",
    "ar": "جبل موسى",
    "city": true,
    "parentId": "151",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      }
    ],
    "pathEn": "Sinai & Red Sea",
    "pathAr": "سيناء والبحر الاحمر"
  },
  {
    "id": "186",
    "en": "St. Catherine",
    "ar": "سانت كاترين",
    "parentId": "185",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      },
      {
        "id": "185",
        "en": "Mount Sinai",
        "ar": "جبل موسى"
      }
    ],
    "pathEn": "Sinai & Red Sea > Mount Sinai",
    "pathAr": "سيناء والبحر الاحمر > جبل موسى"
  },
  {
    "id": "187",
    "en": "Ras Um Sid",
    "ar": "رأس ام سيد",
    "city": true,
    "parentId": "151",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      }
    ],
    "pathEn": "Sinai & Red Sea",
    "pathAr": "سيناء والبحر الاحمر"
  },
  {
    "id": "188",
    "en": "Port Ghalib",
    "ar": "بورت غالب",
    "city": true,
    "parentId": "151",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      }
    ],
    "pathEn": "Sinai & Red Sea",
    "pathAr": "سيناء والبحر الاحمر"
  },
  {
    "id": "189",
    "en": "Marsa Mubarak",
    "ar": "مرسى مبارك",
    "city": true,
    "parentId": "151",
    "path": [
      {
        "id": "151",
        "en": "Sinai & Red Sea",
        "ar": "سيناء والبحر الاحمر"
      }
    ],
    "pathEn": "Sinai & Red Sea",
    "pathAr": "سيناء والبحر الاحمر"
  },
  {
    "id": "190",
    "en": "Port Said",
    "ar": "بور سعيد",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  },
  {
    "id": "191",
    "en": "Port Said Museum",
    "ar": "متحف بورسعيد الحربى",
    "parentId": "190",
    "path": [
      {
        "id": "190",
        "en": "Port Said",
        "ar": "بور سعيد"
      }
    ],
    "pathEn": "Port Said",
    "pathAr": "بور سعيد"
  },
  {
    "id": "192",
    "en": "Qalyubia",
    "ar": "القليوبية",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  },
  {
    "id": "193",
    "en": "Qena",
    "ar": "قنا",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  },
  {
    "id": "194",
    "en": "Dendera Temple Complex",
    "ar": "مجمع معابد دندرة",
    "parentId": "193",
    "path": [
      {
        "id": "193",
        "en": "Qena",
        "ar": "قنا"
      }
    ],
    "pathEn": "Qena",
    "pathAr": "قنا"
  },
  {
    "id": "195",
    "en": "Temple of Khnum",
    "ar": "معبد خنوم",
    "parentId": "193",
    "path": [
      {
        "id": "193",
        "en": "Qena",
        "ar": "قنا"
      }
    ],
    "pathEn": "Qena",
    "pathAr": "قنا"
  },
  {
    "id": "196",
    "en": "Sharqia",
    "ar": "الشرقية",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  },
  {
    "id": "197",
    "en": "Sohag",
    "ar": "سوهاج",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  },
  {
    "id": "198",
    "en": "Abydos Palace",
    "ar": "معبد أبيدوس",
    "parentId": "197",
    "path": [
      {
        "id": "197",
        "en": "Sohag",
        "ar": "سوهاج"
      }
    ],
    "pathEn": "Sohag",
    "pathAr": "سوهاج"
  },
  {
    "id": "199",
    "en": "Suez",
    "ar": "السويس",
    "city": true,
    "path": [],
    "pathEn": "",
    "pathAr": ""
  }
];